<template>
  <div
    class="grid gap-4 justify-between grid-cols-3 md:grid-cols-5 lg:grid-cols-8 xl:grid-cols-10"
  >
    <div
      v-for="n in 10"
      :key="n"
      class="skeleton-item flex flex-col items-center space-y-2"
    >
      <div
        class="sm:size-24 sm:min-w-24 size-18 min-w-18 rounded-full bg-gray-100 animate-pulse"
      ></div>
      <div
        class="sm:h-3 h-2 sm:w-20 w-14 bg-gray-100 animate-pulse rounded"
      ></div>
      <div
        class="sm:h-3 h-2 sm:w-12 w-7 bg-gray-100 animate-pulse rounded"
      ></div>
    </div>
  </div>
</template>

<style scoped>
/* 1. Default (Mobile): Show 3 */
.skeleton-item {
  display: none;
}
.skeleton-item:nth-child(-n + 3) {
  display: flex;
}

/* 2. Tablet (786px+): Show 5 */
@media (min-width: 786px) {
  .skeleton-item:nth-child(-n + 5) {
    display: flex;
  }
}

/* 3. Desktop (1024px+): Show 8 */
@media (min-width: 1024px) {
  .skeleton-item:nth-child(-n + 8) {
    display: flex;
  }
}

/* 4. Wide (1280px+): Show all 10 */
@media (min-width: 1280px) {
  .skeleton-item:nth-child(-n + 10) {
    display: flex;
  }
}
</style>
